import { render, staticRenderFns } from "./CompletedRequest.vue?vue&type=template&id=ebbeeb78"
import script from "./CompletedRequest.vue?vue&type=script&lang=js"
export * from "./CompletedRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports